import React from 'react';

// Bootstrap Components.
import { Input, Label } from 'reactstrap';

function AcknowledgementContent({ acknowledgements = [], acceptedAcknowledgements = [], toggleAcknowledgement = () => null }) {
  return (
    <div className="p-3 rounded-3 surface-elevated">
      {acknowledgements.length > 0 && (
          <div className="d-grid gap-3">
              {acknowledgements.map(({ id, label }) => (
                  <div key={`acknowledgement-${id}`} className="d-flex align-items-center gap-2 px-2">
                      <Input
                          id={id}
                          type="checkbox"
                          checked={acceptedAcknowledgements.includes(id)}
                          data-acknowledgement={id}
                          onChange={toggleAcknowledgement}
                          className="mt-0 acknowledgement-checkbox border-secondary-subtle"
                      />
                      <Label check for={id} className="text-secondary mb-0">
                          {label}
                      </Label>
                  </div>
              ))}
          </div>
      )}
    </div>
  );
}

export default AcknowledgementContent;
